{
  "total": "Tổng giá trị tài sản",
  "available": "Số dư khả dụng",
  "frozen": "Tài sản bị khóa",
  "bonus-balance": "Số dư thưởng",
  "bonus-balance-label": "Số dư thưởng: {{amount}}",
  "action": {
    "deposit": "Nhận token",
    "convert": "Quy đổi",
    "buySellOrder": "Mua bán token",
    "customerService": "Hỗ trợ khách hàng"
  },
  "assets": "Tài sản",
  "coin": {
    "YBB": "Token nền tảng",
    "usdt": "USDT"
  },
  "ticketUsed": "Vé rút thăm này đã được sử dụng hoặc không còn hiệu lực.",
  "ticketWin": "Chúc mừng bạn nhận được {{amount}}{{label}}",
  "ticketNoPrize": "Chưa trúng thưởng, hãy thử lại nhé!",
  "tickets": "Vé rút thăm",
  "close": "Đóng",
  "ticketLoadFailed": "Không thể tải vé rút thăm, vui lòng thử lại sau.",
  "noTickets": "Hiện không có vé rút thăm nào.",
  "unclaimedTicket": "Bạn có một lì xì chưa nhận, hãy chạm để nhận!",
  "drawNow": "Rút thăm ngay",
  "loginToViewTickets": "Vui lòng đăng nhập trước khi xem vé rút thăm.",
  "drawResultUnavailable": "Không thể lấy kết quả rút thăm, vui lòng thử lại sau.",
  "drawFailed": "Rút thăm thất bại, vui lòng thử lại sau.",
  "drawFailedTitle": "Rút thăm thất bại"
}
